/* eslint-disable import/default */
import React from 'react'
import ReactDOM from 'react-dom/client'
import appConfig from '@/configs/app.config'
import { mockServer } from '@/testing/mock'
import { setupGlobalErrorHandling } from '@/utils/globalErrorHandler'
import App from './App'
import './index.css'

// Set up global error handling to prevent production console errors
setupGlobalErrorHandling()

if (appConfig.enableMock) {
    mockServer({ environment: process.env.NODE_ENV })
}
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
)
